<template>
  <ModuleContainer v-bind="bindModule" :btnWidth="70">
    <template #btn>
      <MapControlButton v-if="current_baseMaps" :tooltip="title">
        <v-card
          class="clickable base-map-button__container"
          height="70px"
          width="70px"
          @click="onToggleList"
        >
          <v-img :aspect-ratio="1" :src="current_baseMaps.thumbnail">
            <div class="pa-1 base-map-button__title">
              <v-icon dark small>{{ controlIcon }}</v-icon>
              <div class="">
                {{ title }}
              </div>
            </div>
          </v-img>
        </v-card>
      </MapControlButton>

      <div v-else></div>
    </template>
    <template #draggable="props">
      <DraggablePopup
        v-bind="props"
        :height="70 * (Math.floor(c_baseMaps.length / 3) + 1) + 48 + 2"
        :is-resizable="false"
        :show.sync="p_show"
        :title="title"
        :width="70 * 3 + 16"
        :top="24"
        :right="72"
      >
        <v-card class="d-flex flex-wrap" flat>
          <v-card
            v-for="baseMap in c_baseMaps"
            :key="baseMap.id"
            class="
              clickable
              text-center
              py-2
              px-1
              d-flex
              flex-column
              align-center
            "
            flat
            height="70px"
            :title="baseMap.title"
            width="70px"
            @click="onClick(baseMap)"
          >
            <v-sheet height="36px" width="36px">
              <v-img :aspect-ratio="1" :src="baseMap.thumbnail"> </v-img>
            </v-sheet>
            <div
              class="text-caption text-truncate full-width"
              :class="{
                'primary--text':
                  current_baseMaps && baseMap.id == current_baseMaps.id,
              }"
            >
              {{ baseMap.title }}
            </div>
          </v-card>
        </v-card>
      </DraggablePopup>
    </template>
    <slot />
  </ModuleContainer>
</template>

<script>
import { DraggablePopup } from '@components/draggable'
import ModuleMixin from '@components/Map/mixins/ModuleMixin'
//import MapControlGroupButton from "@components/Map/control/MapControlGroupButton.vue";
import MapControlButton from '@components/Map/control/MapControlButton.vue'
import defaultbasemap from './basemap'
import BaseMapMixin from './BaseMapStore.mixins'
export default {
  components: { MapControlButton, DraggablePopup },
  mixins: [ModuleMixin, BaseMapMixin],
  props: {
    baseMaps: {
      type: Array,
      default: () => defaultbasemap,
    },
    title: {
      type: String,
      default: 'Bản đồ nền',
    },
    defaultBaseMap: {
      type: String,
      default: 'Streets',
    },
    controlIcon: {
      type: String,
      default: 'mdi mdi-layers-outline',
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({ p_baseMaps: [], p_show: false }),
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val !== undefined) this.p_show = val;
      }
    },
    p_show(val) {
      this.$emit('update:show', val)
    },
    baseMaps: {
      immediate: true,
      handler(value) {
        if (!value || value.length < 1) return
        this.p_baseMaps = value
      },
    },
    p_baseMaps: {
      immediate: true,
      handler(value) {
        if (!this.map || !value || value.length < 1) return
        this.onInit()
      },
    },
  },
  methods: {
    onInit() {
      if (this.p_baseMaps.length > 0) {
        this.setBaseMaps(this.p_baseMaps)
      }
    },
    onToggleList() {
      this.p_show = !this.p_show
    },
    onClick(item) {
      if (this.current_baseMaps && item.id === this.current_baseMaps.id) {
        return
      }
      this.loadItem(item)
    },
  },
}
</script>
<style scoped>
.base-map-button__title {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: white;
  background-image: linear-gradient(transparent, rgba(0, 0, 0, 0.6));
}
.base-map-button__title > div {
  font-size: 0.6rem;
}
.base-map-button__container {
  padding: 2px;
}
</style>
